const API_BASE_URL = ''; // 后端地址

export default API_BASE_URL;
